const openInNewTabAttr = (openInNewTab) => {
  return openInNewTab
    ? {
        target: '_blank',
        rel: 'noreferrer',
      }
    : {};
};

export default openInNewTabAttr;
